// extracted by mini-css-extract-plugin
module.exports = {"overflow-x":"hero_overflow-x__AFyzZ","hero-holder":"hero_hero-holder__Y4i3t"};